import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ApiPartnerService } from "@app/api/api-partner.service";
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: "app-master-theme",
  templateUrl: "./master-theme.component.html",
  styleUrls: ["./master-theme.component.css"],
})
export class MasterThemeComponent implements OnInit {
  @ViewChild("closeBtn", { static: false }) closeBtn: ElementRef;

  listThemes: any = [];
  table_load = true;
  paging: any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index: number;
  first_index: number;
  total_count: number;
  querySearch = false;
  searching = false;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";
  limit = 10;
  msearch: string;
  textSearch = new FormControl("");
  alert_act: any = [];
  formSet = this.fb.group({
    themeName: [""],
    themeCode: [""],
    themeFont: [""],
    primaryColor: [""],
    primaryColorOpacity: [""],
    secondaryColor: [""],
    secondaryColorOpacity: [""],
    accentColor: [""],
    logoFile: [""],
    backgroundFile: [""],
    bannerFile: [""],
    supports1File: [""],
    supports2File: [""],
    supports3File: [""],
    flagActive: [""],
  });
  falsemessage: string;
  message: string;
  itemset: any = {};
  selectedLogo: string | ArrayBuffer | null = null;
  selectedLogoFile: File = null;
  selectedBackground: string | ArrayBuffer | null = null;
  selectedBackgroundFile: File = null;
  selectedBanner: string | ArrayBuffer | null = null;
  selectedBannerFile: File = null;
  selectedSupport1: string | ArrayBuffer | null = null;
  selectedSupport1File: File = null;
  selectedSupport2: string | ArrayBuffer | null = null;
  selectedSupport2File: File = null;
  selectedSupport3: string | ArrayBuffer | null = null;
  selectedSupport3File: File = null;

  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.loadStart();
  }

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  loadStart() {
    this.route.queryParams.subscribe((params) => {
      if (params.search != "" && params.search != undefined) {
        this.msearch = params.search;
        this.querySearch = true;

        this.currentParams = params;
        this.queryParams = "?" + this.queryStr(params);
        this.loadThemes(this.queryParams);
      } else {
        this.querySearch = false;
        this.currentParams = params;

        this.queryParams = "?" + this.queryStr(params);
        this.loadThemes(this.queryParams);
      }
    });
    this.msearch = undefined;
  }

  refreshPage() {
    this.ngOnInit();
  }

  search() {
    this.querySearch = true;

    if (this.msearch == undefined) {
      this.msearch = "";
    }
    if (this.limit != undefined) {
      this.searchQueryParams =
        "?page=" + this.page_self["page"] + "&search=" + this.msearch;
    }
    this.loadThemes(this.searchQueryParams);
  }

  onActionClick(act: any, item: any) {
    this.alert_act = act;

    if (this.alert_act == "add") {
      this.clearForm();
    }
    if (this.alert_act == "view") {
      this.itemset = item;
      this.clearForm();
      this.loadThemeDetail(this.itemset.id);
    }
  }

  onFileSelected(event: Event, fileType: string): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0]; // Ambil file yang dipilih
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent) => {
        const fileReader = e.target as FileReader;

        if (fileReader) {
          if (fileType === "logo") {
            this.selectedLogo = fileReader.result;
            this.selectedLogoFile = file; // Simpan hasil sebagai data URL untuk preview
            // this.formSet.get("logoFile").setValue(file);
          } else if (fileType === "background") {
            this.selectedBackground = fileReader.result;
            this.selectedBackgroundFile = file;
            // this.formSet.get("backgroundFile").setValue(file);
          } else if (fileType === "banner") {
            this.selectedBanner = fileReader.result;
            this.selectedBannerFile = file;
            // this.formSet.get("backgroundFile").setValue(file);
          } else if (fileType === "supports1") {
            this.selectedSupport1 = fileReader.result;
            this.selectedSupport1File = file;
          } else if (fileType === "supports2") {
            this.selectedSupport2 = fileReader.result;
            this.selectedSupport2File = file;
          } else if (fileType === "supports3") {
            this.selectedSupport3 = fileReader.result;
            this.selectedSupport3File = file;
          }
        }
      };

      reader.readAsDataURL(file);
    }
  }

  clearForm() {
    this.formSet.reset();
    this.formSet.get("themeName").setValue(undefined);
    this.formSet.get("themeCode").setValue(undefined);
    this.formSet.get("themeFont").setValue(undefined);
    this.formSet.get("primaryColor").setValue(undefined);
    this.formSet.get("primaryColorOpacity").setValue(undefined);
    this.formSet.get("secondaryColor").setValue(undefined);
    this.formSet.get("secondaryColorOpacity").setValue(undefined);
    this.formSet.get("accentColor").setValue(undefined);
    this.formSet.get("logoFile").setValue(undefined);
    this.formSet.get("backgroundFile").setValue(undefined);
    this.formSet.get("bannerFile").setValue(undefined);
    this.formSet.get("supports1File").setValue(undefined);
    this.formSet.get("supports2File").setValue(undefined);
    this.formSet.get("supports3File").setValue(undefined);
    this.formSet.get("flagActive").setValue(undefined);
    this.selectedLogo = null;
    this.selectedLogoFile = null;
    this.selectedBackground = null;
    this.selectedBackgroundFile = null;
    this.selectedBanner = null;
    this.selectedBannerFile = null;
    this.selectedSupport1 = null;
    this.selectedSupport2 = null;
    this.selectedSupport3 = null;
    this.selectedSupport1File = null;
    this.selectedSupport2File = null;
    this.selectedSupport3File = null;
  }

  loadThemes(params: any) {
    this.table_load = true;

    return this.partnerService.GetThemes(params).subscribe((output: any) => {
      this.listThemes = output.data;
      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta["totalCount"];
      let self = this.page_self["page"];
      if (self * this.meta["perPage"] < this.meta["totalCount"]) {
        this.last_index = self * this.meta["perPage"];
      } else {
        this.last_index = this.meta["totalCount"];
      }
      this.first_index = (self - 1) * this.meta["perPage"] + 1;
    });
  }

  loadThemeDetail(id: any) {
    this.partnerService.GetThemeDetail(id).subscribe((output: any) => {
      let data = output.data;
      this.formSet.get("themeName").setValue(data.name);
      this.formSet.get("themeCode").setValue(data.code);
      this.formSet.get("themeFont").setValue(data.font);
      this.formSet.get("primaryColor").setValue(data.color.primary);
      this.formSet
        .get("primaryColorOpacity")
        .setValue(data.color.primary_opacity);
      this.formSet.get("secondaryColor").setValue(data.color.secondary);
      this.formSet
        .get("secondaryColorOpacity")
        .setValue(data.color.secondary_opacity);
      this.formSet.get("accentColor").setValue(data.color.accent);
      this.selectedLogo = data.logo;
      this.selectedBackground = data.background;
      this.selectedBanner = data.banner;
      data.supports.forEach((support, index) => {
        switch (index) {
          case 0:
            this.selectedSupport1 = support.url;
            break;
          case 1:
            this.selectedSupport2 = support.url;
            break;
          case 2:
            this.selectedSupport3 = support.url;
            break;
        }
      });
      this.formSet.get("flagActive").setValue(data.flag_active.toString());
    });
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  alertsx(message: any) {
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(() => {
      this.closeModal();
      this.ngOnInit();
    }, 1000);
  }

  alertfx(message: any) {
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
  }

  submitAdd() {
    const formData = new FormData();
    formData.append("name", this.formSet.get("themeName").value);
    formData.append("code", this.formSet.get("themeCode").value);
    formData.append("font", this.formSet.get("themeFont").value);
    formData.append("colors[primary]", this.formSet.get("primaryColor").value);
    formData.append(
      "colors[primary_opacity]",
      this.formSet.get("primaryColorOpacity").value
    );
    formData.append(
      "colors[secondary]",
      this.formSet.get("secondaryColor").value
    );
    formData.append(
      "colors[secondary_opacity]",
      this.formSet.get("secondaryColorOpacity").value
    );
    formData.append("colors[accent]", this.formSet.get("accentColor").value);
    formData.append("flagActive", this.formSet.get("flagActive").value);

    if (this.formSet.get("logoFile").value) {
      formData.append("logo", this.selectedLogoFile);
    }
    if (this.formSet.get("backgroundFile").value) {
      formData.append("background", this.selectedBackgroundFile);
    }
    if (this.formSet.get("bannerFile").value) {
      formData.append("banner", this.selectedBannerFile);
    }
    if (this.formSet.get("supports1File").value) {
      formData.append("supports_1", this.selectedSupport1File);
    }
    if (this.formSet.get("supports2File").value) {
      formData.append("supports_2", this.selectedSupport2File);
    }
    if (this.formSet.get("supports3File").value) {
      formData.append("supports_3", this.selectedSupport3File);
    }

    this.partnerService.CreateTheme(formData).subscribe((output: any) => {
      if (output) {
        if (output.status == true) {
          this.message = output.message;
          this.alertsx(this.message);
        } else {
          this.message = output.message;
          this.alertfx(this.message);
        }
      } else {
        this.alertfx("Error hit API");
      }
    });
  }

  submitSet() {
    let id = this.itemset.id;
    const formData = new FormData();
    formData.append("name", this.formSet.get("themeName").value);
    formData.append("code", this.formSet.get("themeCode").value);
    formData.append("font", this.formSet.get("themeFont").value);
    formData.append("colors[primary]", this.formSet.get("primaryColor").value);
    formData.append(
      "colors[primary_opacity]",
      this.formSet.get("primaryColorOpacity").value
    );
    formData.append(
      "colors[secondary]",
      this.formSet.get("secondaryColor").value
    );
    formData.append(
      "colors[secondary_opacity]",
      this.formSet.get("secondaryColorOpacity").value
    );
    formData.append("colors[accent]", this.formSet.get("accentColor").value);
    formData.append("flagActive", this.formSet.get("flagActive").value);

    if (this.formSet.get("logoFile").value) {
      formData.append("logo", this.selectedLogoFile);
    }
    if (this.formSet.get("backgroundFile").value) {
      formData.append("background", this.selectedBackgroundFile);
    }
    if (this.formSet.get("bannerFile").value) {
      formData.append("banner", this.selectedBannerFile);
    }
    if (this.formSet.get("supports1File").value) {
      formData.append("supports_1", this.selectedSupport1File);
    }
    if (this.formSet.get("supports2File").value) {
      formData.append("supports_2", this.selectedSupport2File);
    }
    if (this.formSet.get("supports3File").value) {
      formData.append("supports_3", this.selectedSupport3File);
    }
    formData.forEach((value, key) => {
      console.log(key, value);
    });
    this.partnerService.UpdateTheme(id, formData).subscribe((output: any) => {
      if (output.status == true) {
        this.message = output.message;
        this.alertsx(this.message);
      } else {
        this.message = output.message;
        this.alertfx(this.message);
      }
    });
  }

  submitDelete() {
    let id = this.itemset.id;
    swal({
      title: "Are you sure?",
      text:
        '"' +
        this.itemset.name +
        '" ("' +
        this.itemset.code +
        '") Akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.partnerService.DeleteTheme(id).subscribe((output: any) => {
          if (output.status == true) {
            this.message = output.message;
            this.alertsx(this.message);
          } else {
            this.message = output.message;
            this.alertfx(this.message);
          }
        });
      }
    });
  }

  isImage(file: string): boolean {
    return file.match(/\.(jpeg|jpg|gif|png)$/i) !== null;
  }

  isVideo(file: string): boolean {
    return file.match(/\.(mp4|webm|ogg)$/i) !== null;
  }

  loadImage(fileName: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(
      this.partnerService.LoadImageTheme(fileName)
    );
  }
}
